$(document).ready(function(){
    $("main .top_bar .close").click(function(){
        $(this).parent(".top_bar").removeClass("wow bounceInDown");
        $(this).parent(".top_bar").addClass("hide");
    });
    $("main header .header_area > li:nth-child(3) > span.bars").click(function(){
        $("main header .header_area > li:nth-child(2)").fadeIn().addClass("active");
    });
    $("main header .header_area > li:nth-child(2) .close").click(function(){
        $("main header .header_area > li:nth-child(2)").fadeOut().removeClass("active");
    });
    function moboutsidehide(){
        var a = $(window).innerWidth();
        if(a <= 991){
            $("main header > .fw .header_area > li:nth-child(2).active .fw").click(function(e){
                e.stopPropagation();
            });
            $("main header > .fw .header_area > li:nth-child(2)").click(function(){
                $(this).fadeOut().removeClass("active");
            });
        }
    }
    $(window).resize(moboutsidehide);
    $(window).on('load', moboutsidehide());
});
$(document).ready(function(){
    new WOW().init();
    
    //==select_box
    $(".select_box > span").click(function(){
        $(".select_box").removeClass("active");
        $(this).parent(".select_box").addClass("active");
     });
     $(".after").click(function(){
        $(this).parent(".select_box").removeClass("active");
     });
     $(".select_box > ul > li").click(function(){
         $(this).parent().parent().removeClass("active");
         var t = $(this).text();
         $(this).parent().siblings("span").text(t);
     });
     $(".select_box").click(function(e){
       e.stopPropagation();
     });
     $(document).click(function(){
       $(".select_box").removeClass("active");
     });
     //==select_box

     //==choice_accordion
     $("main .section.choice .accordion_area .acc_tabs > a.active").each(function(){
        $($(this).attr("data-target")).addClass("active");
     });
     $("main .section.choice .accordion_area .acc_tabs > a").click(function(){
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
        $($(this).attr("data-target")).addClass("active");
        $($(this).attr("data-target")).siblings().removeClass("active");
     });
    //==choice_accordion

    // search_bar
    $("main header .header_area > li:nth-child(3) > span.search").click(function(){
        $("main .search_bar").fadeIn();
    });
    $("main .search_bar > form .heading > .close").click(function(){
        $(this).closest(".search_bar").fadeOut();
    });
    $("main .search_bar > form .fw input").on("keyup", function() {
        var value = $(this).val().toLowerCase();
        $(this).parent().siblings(".dropdown").children("li").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
        });
    });
    // search_bar
    
});
$(document).ready(function(){
    //==choice_slider
    $('#tab_1, #tab_2, #tab_3, #tab_4, #tab_5, #tab_6').owlCarousel({
        autoplay:false,
        loop:true,
        nav:false,
        dots:true,
        margin:0,
        responsive:{
            0:{
                items:2,
            },            
            576:{
                items:2
            },            
            992:{
                items:3
            },
            1200:{
               items:4
           }
        }
    });
   //  one.on('mousewheel', '.owl-stage', function (e) {
   //      if (e.deltaY>0) {
   //          owl.trigger('next.owl');
   //      } else {
   //          owl.trigger('prev.owl');
   //      }
   //      e.preventDefault();
   //  });
   //==choice_slider

   $('main .reviews .reviews_slider').owlCarousel({
       autoplay:true,
       center: true,
       loop:true,
       nav:true,
       dots:false,
       margin:30,
       responsive:{
           0:{
               items:1,
               margin:5,
           },            
           576:{
               items:2
           },            
           992:{
               items:3
           },
           1200:{
              items:3
          }
       }
   });

   $('.inspiration .acc_body_slider').owlCarousel({
       autoplay:false,
       loop:true,
       nav:false,
       dots:true,
       margin:0,
       responsive:{
           0:{
               items:2
           },            
           576:{
               items:2
           },            
           768:{
               items:3
           },
           1200:{
              items:4
          },
          1700:{
           items:5
          },
          2100:{
           items:6
          },
          2400:{
           items:7
          },
          2700:{
           items:8
          },
          3000:{
             items:7
          },
          3300:{
             items:8
           },
           3600:{
             items:9
           },
           3900:{
               items:12
           }
       }
   });

   $('.connect .slider').owlCarousel({
       autoplay:true,
       loop:true,
       nav:false,
       dots:false,
       margin:3,
       responsive:{
           0:{
               items:4
           },
           1200:{
              items:5
          },
          1700:{
           items:5
          },
          2100:{
           items:6
          },
          2400:{
           items:7
          },
          2700:{
           items:8
          },
          3000:{
             items:7
          },
          3300:{
             items:8
           },
           3600:{
             items:9
           },
           3900:{
               items:12
           }
       }
   });

   $('.recipes .slider').owlCarousel({
    autoplay:true,
    loop:true,
    nav:false,
    dots:false,
    margin:30,
    responsive:{
        0:{
            items:2,
            margin:10,
        },
        576:{
            items:2
        },
        992:{
            items:3
        },
        1200:{
           items:4
       }
    }
});
   //video slider home page
//    $('main .section.video .img_area').owlCarousel({
//        autoplay:true,
//        autoplayTimeout:14000,
//        loop:true,
//        nav:false,
//        dots:false,
//        margin:0,
//        items:1,
//    });
   //video slider home page
});
// $(document).ready(function(){
//     function header(){
//         var a = $(window).scrollTop();
//         var b = $("main header .top_bar").height();
//         if(a >= b){
//             $("main header").addClass("active");
//             $("main header, main header *").removeAttr("style");
//         }else{
//             $("main header").removeClass("active");
//         };
//     }
//     $(window).scroll(header);
//     $(window).on('load', header());
// });

$(document).ready(function(){
    function product_page(){
        var ww = $(window).innerWidth() || $(document).innerWidth();
        if(ww >= 1200){
            var $sticky = $("main .section.zoom_area .fix_area .main_fix_area");
            var $stickyrStopper = $("main .section.favorite");
            if (!!$sticky.offset()) {
                var generalSidebarHeight = $sticky.innerHeight();
                var stickyTop = $sticky.offset().top;
                var windowWidth = $(window).innerWidth() || $(document).innerWidth();
                if (windowWidth >= 1200){
                    var stickOffset = 134;
                }
                var stickyStopperPosition = $stickyrStopper.offset().top;
                var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
                var diff = stopPoint + stickOffset;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    if (stopPoint < windowTop) {
                        $sticky.css({ position: 'static', top: diff - stickOffset});
                    }
                    else if (stickyTop < windowTop + stickOffset){
                        $sticky.css({ position: 'fixed', top: stickOffset });
                    }
                    else {
                        $sticky.css({ position: 'static', top: 'initial' });
                    }
                });
            }
        }
    }
    $(window).on("resize", product_page());
    $(window).on("scroll", product_page);
    $(window).on("load", product_page());
});
$(document).ready(function(){
    $("main .section.zoom_area .fix_area .main_fix_area .accordion_area > li .hd").click(function(){
        $(this).closest("li").toggleClass("active");
        $(this).closest("li").siblings().removeClass("active");
    });
});

// for the mobile sticky filter of collection page
/*
$(document).ready(function(){
    function mobfilter(){
        var a = $(window).innerWidth() || $(document).innerWidth();
        console.log(a);
        if(a <= 575){
            var a = $(window).scrollTop() || $(document).scrollTop();
            var b = 63+220+51+60;
            var main = $("main").height();
            var footer = $("main footer").height();
            var filter = $("main .filter").height();
            if(a >= b && a <= main - footer - filter - 63 - 200){
                $("main .filter").addClass("active");
            }else{
                $("main .filter").removeClass("active");
            };
        }
    }
    $(window).scroll(mobfilter);
    $(window).resize(mobfilter);
    $(window).load(mobfilter());
});
*/
// for the mobile sticky filter of collection page

// YouTube Player API for header BG video

// Insert the <script> tag targeting the iframe API
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const classCheck2 = document.querySelector('js-background-video');

if (classCheck2 !=null && classCheck2.length > 0) {
// Get the video ID passed to the data-video attribute
const bgVideoID = document.querySelector('.js-background-video').getAttribute('data-video');

// Set the player options
const playerOptions = {
  // Autoplay + mute has to be activated (value = 1) if you want to autoplay it everywhere 
  // Chrome/Safari/Mobile
  autoplay: 1,
  mute: 1,
  autohide: 1, 
  modestbranding: 1, 
  rel: 0, 
  showinfo: 0, 
  controls: 0, 
  disablekb: 1, 
  enablejsapi: 1, 
  iv_load_policy: 3,
  // For looping video you have to have loop to 1
  // And playlist value equal to your currently playing video
  loop: 1,
  playlist: bgVideoID,
  
}
}

const classCheck = document.querySelector('.js-video-overlay');

if (classCheck !=null && classCheck.length > 0) {
// Get the video overlay, to mask it when the video is loaded
const videoOverlay = document.querySelector('.js-video-overlay');

// This function creates an <iframe> (and YouTube player)
// after the API code downloads.
let ytPlayer;
function onYouTubeIframeAPIReady() {
  ytPlayer = new YT.Player('yt-player', {
    width: '1280',
    height: '720',
    videoId: bgVideoID,
    playerVars: playerOptions,
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
}
  
}
// // Get the video overlay, to mask it when the video is loaded
// const videoOverlay = document.querySelector('.js-video-overlay');

// // This function creates an <iframe> (and YouTube player)
// // after the API code downloads.
// let ytPlayer;
// function onYouTubeIframeAPIReady() {
//   ytPlayer = new YT.Player('yt-player', {
//     width: '1280',
//     height: '720',
//     videoId: bgVideoID,
//     playerVars: playerOptions,
//     events: {
//       'onReady': onPlayerReady,
//       'onStateChange': onPlayerStateChange
//     }
//   });
// }

// The API will call this function when the video player is ready.
function onPlayerReady(event) {
  event.target.playVideo();

  // Get the duration of the currently playing video
  const videoDuration = event.target.getDuration();
  
  // When the video is playing, compare the total duration
  // To the current passed time if it's below 2 and above 0,
  // Return to the first frame (0) of the video
  // This is needed to avoid the buffering at the end of the video
  // Which displays a black screen + the YouTube loader
  setInterval(function (){
    const videoCurrentTime = event.target.getCurrentTime();
    const timeDifference = videoDuration - videoCurrentTime;
    
    if (2 > timeDifference > 0) {
      event.target.seekTo(0);
    }
  }, 1000);
}

// When the player is ready and when the video starts playing
// The state changes to PLAYING and we can remove our overlay
// This is needed to mask the preloading
function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING) {
    videoOverlay.classList.add('header__video-overlay--fadeOut');
  }
}